import {Fragment, h} from 'preact';
import DeviceBadInfo from "./DeviceBadInfo";

export default function Device({device, contract, account, formParams}){
	return (
		<div className={"debt-table-item debt-table__item " + (!formParams.allowedPayment ? 'debt-table-item-2_not-padding':'')}>
			<div className="debt-table-item-2__row">
				<div className="debt-table-item-2__col">
					<div className="debt-table-item-2__col-title">Прибор учёта</div>
					<div className="debt-table-item-2__counter-readings">{device.serialNumber}</div>
				</div>
				<div className="debt-table-item-2__col">
					{device.stateStatus === 'working' && (
						<Fragment>
							<div className="debt-table-item-2__col-title">Показания прибора учёта</div>
							{['normative', 'contractual'].indexOf(device.calculateMethod) !== -1 && (
								<div className="debt-table-item-2__counter-info">
									<div>{device.calculateMethod === 'normative' ? 'По нормативу':'По договору'}</div>
									<div className="debt-table-item-2__counter-result">{device.normativeMeterReading}</div>
									<div className="debt-table-item-2__counter-date" dangerouslySetInnerHTML={{__html: device.unit + ' в мес'}}/>
								</div>
							)}
							{device.calculateMethod === 'indications' && (
								<div className="debt-table-item-2__counter-info">
									<div className="debt-table-item-2__counter-result">{device.meterReading}</div>
									<div className="debt-table-item-2__counter-date">от {device.dateMeterReading}</div>
								</div>
							)}
							<div className="debt-table-item-2__button-container">
								{device.canEnterMeterReadings && (
									<button className="button-primary button-primary_bgc_brand-2 button-primary_pdv_sm debt-table-item-2__counter-btn" data-modal-url={device.enterUrl} onClick={() => {window.reachGoal('meters')}}>
										<span className="button-primary__text">Передать показания</span><span className="button-primary__icon button-primary__icon_sz_sm js__tooltip" title="Передача показаний необходима для точного расчета задолженности"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z" fill="black"/></svg></span>
									</button>
								)}
								<a className="button-primary button-primary_pdv_sm" href={"/accounts-details/?f%5BprodType%5D="+ contract.prodType +"&f%5BaccountId%5D=" + account.id}>Расшифровка счета</a>
							</div>
						</Fragment>
					)}
				</div>
			</div>
			<DeviceBadInfo device={device} contract={contract} account={account} formParams={formParams}/>
		</div>
	)
}
